(() => {
  const banner = document.getElementById('omni-cookie-banner');
  if (!banner) return;
  const error = banner.querySelector('.omni-cookie-error');
  const buttons = [...banner.querySelectorAll('button')];
  let api;
  let returnFocus;
  let pending = false;
  let dismissed = false;
  let manualAt = null;
  const syncScroll = () => {
    if (banner.hidden) return;
    if (manualAt !== null && Math.abs(window.scrollY - manualAt) > 20) manualAt = null;
    const offscreen = manualAt === null && (window.scrollY > 80 || !pending || dismissed);
    banner.classList.toggle('omni-cookie-away', offscreen);
    banner.inert = offscreen;
    banner.setAttribute('aria-hidden', String(offscreen));
  };
  window.addEventListener('scroll', syncScroll, {passive:true});
  const open = (focus = false) => {
    banner.hidden = false;
    dismissed = false;
    manualAt = focus ? window.scrollY : null;
    syncScroll();
    if (focus) { returnFocus = document.activeElement; banner.querySelector('[data-cookie-choice="reject"]').focus({preventScroll:true}); }
  };
  const close = () => { dismissed = true; manualAt = null; banner.hidden = true; if (returnFocus?.isConnected) returnFocus.focus({preventScroll:true}); };
  banner.querySelector('.omni-cookie-close').addEventListener('click', close);
  banner.querySelectorAll('[data-cookie-choice]').forEach(button => button.addEventListener('click', () => {
    if (!api) return;
    const granted = button.dataset.cookieChoice === 'accept';
    error.hidden = true;
    buttons.forEach(b => b.disabled = true);
    const done = failure => {
      buttons.forEach(b => b.disabled = false);
      if (failure?.error) { error.hidden = false; return; }
      pending = false;
      close();
    };
    try { api.setTrackingConsent({analytics:granted, marketing:granted, preferences:granted}, done); }
    catch (_) { done({error:true}); }
  }));
  document.addEventListener('click', event => {
    if (!api || !event.target.closest('a[href="#shopifyReshowConsentBanner"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(true);
  }, true);
  const ready = () => {
    api = window.Shopify?.customerPrivacy;
    if (!api) return;
    document.documentElement.classList.add('omni-cookie-ready');
    const consent = api.currentVisitorConsent();
    pending = ['analytics','marketing','preferences'].some(key => !consent[key]);
    if (pending) open();
  };
  let attempts = 0;
  const load = () => {
    if (window.Shopify?.customerPrivacy) return ready();
    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], failure => { if (!failure) ready(); });
    } else if (++attempts < 40) setTimeout(load, 250);
  };
  load();
})();
